import Input from "../components/common/Input";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { fetchCreate, fetchIdentitiesCreate, sendEmailVerification, sendPhoneVerification } from "./FetchAuth";
import { updateUserInfo } from "../store/actions/userAction";
import { useDispatch, useSelector } from "react-redux";
import DropdownInput from "../components/common/DropdownInput";
import 'react-datepicker/dist/react-datepicker.css';
import Popup from "../components/common/Popup";
import PrivacyPolicy from "../components/features/PrivacyPolicy";
import Terms from "../components/features/Terms";
import PhoneInput from "react-phone-input-2";
import '../assets/styles/css/phone-input.css'

const SignUp = () => {
  const { t } = useTranslation();
  const userInfo = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [fname, setfname] = useState("");
  const [lname, setlname] = useState("");
  const [mname, setmname] = useState("");
  const [code, setCode] = useState("");
  const [codePhone, setCodePhone] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const emailRef = useRef(null);
  const codeRef = useRef(null);
  const codePhoneRef = useRef(null);
  const confirmPasswordRef = useRef(null);

  const [step, setStep] = useState(0);

  useEffect(() => {
    if (userInfo.NotCompleted) {
      // userInfo.id && 
      setStep(1);
    }
  }, [userInfo]);

  const [errors, setErrors] = useState({
    fname: "",
    lname: "",
    email: "",
    code: "",
    phone: "",
    password: "",
    confirmPassword: "",
    midleName: "",
  });
  const [state, setState] = useState("normal");
  const [stateCode, setStateCode] = useState(state); // add state for code
  const [stateCodePhone, setStateCodePhone] = useState(state);
  const [stateEmail, setStateEmail] = useState(state);
  const [statePhone, setStatePhone] = useState(state);
  const [statePassword, setStatePassword] = useState(state);
  const [stateConfirmPassword, setStateConfirmPassword] = useState(state);

  const [agreement, setAgreement] = useState(false);

  const resetErrors = () => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      fname: "",
      lname: "",
      email: "",
      code: "",
      phone: "",
      password: "",
      confirmPassword: "",
      codePhone: "",
    }));
    setState("normal");
    setStateCode("normal");
    setStateEmail("normal");
    setStatePassword("normal");
    setStateConfirmPassword("normal");
    setStateCodePhone("normal");
    setStatePhone("normal");
  };

  const handlefnameChange = (e) => {
    // handle first name change
    setfname(e.target.value);
    resetErrors();
  };

  const handlemidleNameChange = (e) => {
    // handle midle name change
    setmname(e.target.value);
    resetErrors();
  }

  const handlelnameChange = (e) => {
    // handle last name change
    setlname(e.target.value);
    resetErrors();
  };

  const handleEmailChange = (e) => {
    // handle email change
    setEmail(e.target.value);
    resetErrors();
  };

  const handlePhoneNumberChange = (e) => {
    // handle phone number change
    setPhone(e.target.value);
    resetErrors();
  };

  const handleCodeChange = (e) => {
    setCode(e.target.value);
    resetErrors();
  };

  const handleCodeChangePhone = (e) => {
    setCodePhone(e.target.value);
    resetErrors();
  }

  const handlePasswordChange = (e) => {
    // handle password change
    setPassword(e.target.value);
    resetErrors();

    if (e.target.value.length < 8) {
      // check if the password is at least 8 characters long
      setStatePassword("error");
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: t("The password must be at least 8 characters long."),
      }));
    } else if (!/[A-Z]/.test(e.target.value)) {
      // check if the password contains at least one capital letter
      setStatePassword("error");
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: t("The password must contain at least one capital letter."),
      }));
    } else if (!/[a-z]/.test(e.target.value)) {
      // check if the password contains at least one lowercase letter
      setStatePassword("error");
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: t("The password must contain at least one lowercase letter."),
      }));
    } else if (!/\d/.test(e.target.value)) {
      // check if the password contains at least one digit
      setStatePassword("error");
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: t("The password must contain at least one digit."),
      }));
    }

    if (e.target.value !== confirmPassword && confirmPassword) {
      // check if the password matches the confirm password
      setStateConfirmPassword("error");
      setErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: t("Passwords do not match."),
      }));
    }
  };

  const handleConfirmPasswordChange = (e) => {
    // handle confirm password change
    setConfirmPassword(e.target.value);
    resetErrors();
    if (e.target.value !== password) {
      // check if the confirm password matches the password
      setStateConfirmPassword("error");
      setErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: t("Passwords do not match."),
      }));
    }
  };

  const handleAgreement = () => {
    // handle i agree change
    setAgreement(!agreement);
  };

  const handleSubmit = (e) => {
    // handle form submit
    e.preventDefault();
    if (confirmPassword === password) {
      // check if the confirm password matches the password
      fetchCreate({
        fname,
        mname,
        lname,
        code,
        codePhone,
        email,
        phone,
        password,
        confirmPassword,
      }).then((data) => {
        if (data.success) {
          updateUserInfo(dispatch, data.userData);
          console.log(data.userData);
          setStep(1);
        }
        if (data.error === "email.wrong_code") {
          setErrors((prevErrors) => ({
            ...prevErrors,
            code: t("Invalid code"),
          }));
          setStateCode("error");
          codeRef.current.focus();
        } else if (data.error === "phone.expired_request") {
          setErrors((prevErrors) => ({
            ...prevErrors,
            codePhone: t("Invalid code"),
          }));
          setStateCodePhone("error");
          codePhoneRef.current.focus();
        }
      });
    } else if (confirmPassword !== password) {
      confirmPasswordRef.current.focus();
    }
  };

  const timerAction = (name) => {
    const currentDate = new Date();
    const expirationDate = new Date(currentDate.getTime() + 30 * 1000);  // Cookie буде дійсне 30 секунд
    // Створення cookie з атрибутами SameSite та Secure
    document.cookie = `${name}=${currentDate.toISOString()}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax; Secure`;
  }

  const verificationAction = (email) => {
    // add verificationAction function
    sendEmailVerification(email).then((data) => {
      if (data.status === 200) {
        setStateEmail("success");
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: t("Verification code has been sent"),
        }));
      } else if (data.status === 409) {
        emailRef.current.focus();
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: t("Email already exists."),
        }));
        setStateEmail("error");
      }
    });
    timerAction("timestampemail");
  };

  const verificationActionPhone = (phone) => {
    // add verificationAction function
    sendPhoneVerification(phone).then((data) => {
      if (data.status === 200) {
        setStatePhone("success");
        setErrors((prevErrors) => ({
          ...prevErrors,
          phone: t("Verification code has been sent"),
        }));
      } else if (data.status === 409) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          phone: t("Phone number already exists."),
        }));
        setStatePhone("error");
      }
    });
    timerAction("timestampphone");
  }

  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [country, setCountry] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [isoDate, setIsoDate] = useState('');

  const handleChange = (event) => {
    const dateValue = event.target.value; // Рядок у форматі "YYYY-MM-DD"
    if (dateValue) {
      setSelectedDate(dateValue);
      const date = new Date(dateValue);
      date.setHours(0, 0, 0, 0); // Встановлюємо час на початок дня
      const isoString = date.toISOString();
      setIsoDate(isoString);
      setDatePikerError("");
      setDatePikerState("");
    } else {
      setSelectedDate('');
      setIsoDate('');
    }
  };

  const handleAddressChange = (e) => {
    setAddress(e.target.value);
  };
  const handleCityChange = (e) => {
    setCity(e.target.value);
  }
  const handleZipCodeChange = (e) => {
    setZipCode(e.target.value);
  }

  const handleSubmitIdentities = (e) => {
    e.preventDefault();
    fetchIdentitiesCreate({
      address,
      birthday: isoDate,
      city,
      country: country,
      user: userInfo.id,
      zipCode,
    }).then((data) => {
      if (data.success) {
        updateUserInfo(dispatch, { ...data.userData, isAuth: true });
        console.log(data.userData);
      } else {
        setDatePikerError(t("The minimum age for registration is 21 years old"));
        setDatePikerState("error");
      }
    });
  }

  const [pupupPrivacyPolicy, setPupupPrivacyPolicy] = useState(false);
  const privacyPolicy = () => {
    setPupupPrivacyPolicy(true);
  }
  const [pupupTerms, setPupupTerms] = useState(false);
  const tearmAndConditions = () => {
    setPupupTerms(true);
  }
  const [datePikerError, setDatePikerError] = useState("");
  const [datePikerState, setDatePikerState] = useState("error");
  return (
    <div className="sign-up">
      <h1 className="heading">{t("Welcome to CryptoHub")}</h1>
      <p className="to-sign-in">
        {t("Already have an account?")}{" "}
        <NavLink to={`/sign-in`}>{t("Sign In")}</NavLink>
      </p>

      <div className="sign-up-step"><div className="active"></div><div className={step ? "active" : ""}></div></div>

      <Popup isOpen={pupupTerms} onClose={() => setPupupTerms(false)}>
        <div style={{ maxWidth: "805px" }} className="popup-content terms">
          <Terms />
          <button
            onClick={() => setPupupTerms(false)}
            type="button"
            className="closed-button"
          >
            <i className="ri-close-large-line"></i>
          </button>
        </div>
      </Popup>

      <Popup isOpen={pupupPrivacyPolicy} onClose={() => setPupupPrivacyPolicy(false)}>
        <div style={{ maxWidth: "805px" }} className="popup-content terms">

          <PrivacyPolicy />
          <button
            onClick={() => setPupupPrivacyPolicy(false)}
            type="button"
            className="closed-button"
          >
            <i className="ri-close-large-line"></i>
          </button>
        </div>
      </Popup>
      {!step ? (<form onSubmit={handleSubmit}>
        <div className="form-default flex-column">
          <div className="grid-columns-2">
            <Input
              id="first-name"
              label={t("First Name")}
              type="text"
              value={fname}
              onChange={handlefnameChange}
              placeholder={t("Enter first name")}
              state={state}
              pattern="^[A-Za-zА-Яа-яЁёІіЇїЄєҐґÄÖÜäöüßÁČĎÉÍĽĹŇÓÔŔŠŤÚÝŽáčďéíľĺňóôŕšťúýž]+$"
              required
            />
            <Input
              id="midle-name"
              label={t("Midle Name(Optionaly)")}
              type="text"
              value={mname}
              onChange={handlemidleNameChange}
              placeholder={t("Enter midle name")}
              state={state}
              pattern="^[A-Za-zА-Яа-яЁёІіЇїЄєҐґÄÖÜäöüßÁČĎÉÍĽĹŇÓÔŔŠŤÚÝŽáčďéíľĺňóôŕšťúýž]+$"
            />

          </div>

          <Input
            id="last-name"
            label={t("Last Name")}
            type="text"
            value={lname}
            onChange={handlelnameChange}
            placeholder={t("Enter last name")}
            state={state}
            pattern="^[A-Za-zА-Яа-яЁёІіЇїЄєҐґÄÖÜäöüßÁČĎÉÍĽĹŇÓÔŔŠŤÚÝŽáčďéíľĺňóôŕšťúýž]+$"
            required
          />

          <Input
            id="email"
            label={t("Email")}
            type="email"
            value={email}
            onChange={handleEmailChange}
            placeholder={t("Enter email")}
            state={stateEmail}
            alertState={errors.email}
            ref={emailRef}
            pattern=".*"
            required
          />

          <Input
            id="code"
            label={t("Verification code")}
            type="code"
            value={code}
            onChange={handleCodeChange}
            placeholder={t("6-digit number")}
            state={stateCode}
            alertState={errors.code}
            action={() => verificationAction(email)}
            textAction={t("Send")}
            timerAcrion={30}
            cookieName="timestampemail"
            ref={codeRef}
            pattern="^[0-9]{6}$"
            required
          />

          {/* <Input
            id="phone-number"
            label={t("Phone number")}
            type="tel"
            value={phone}
            onChange={handlePhoneNumberChange}
            placeholder="+__ (___)-___-__-__"
            state={statePhone}
            alertState={errors.phone}
            required
          /> */}


          {/* <PhoneInput
            country={'us'}
            value={phone}
            onChange={phone => setPhone(phone)}
            enableSearch={true}
          /> */}

          <div className="component-input">
            <label htmlFor="phone-number">{t("Phone number")}</label>


            <PhoneInput
              country={'us'}
              value={phone}
              onChange={phone => setPhone(phone)}
              enableSearch={true}
            />

            {errors.phone && <p className={statePhone}>{errors.phone}</p>}
          </div>


          <Input
            id="code-phone"
            label={t("Verification code from your phone")}
            type="code"
            value={codePhone}
            onChange={handleCodeChangePhone}
            placeholder={t("6-digit number")}
            state={stateCodePhone}
            alertState={errors.codePhone}
            action={() => verificationActionPhone(phone)}
            textAction={t("Send")}
            timerAcrion={30}
            cookieName="timestampphone"
            ref={codePhoneRef}
            pattern="^[0-9]{6}$"
            required
          />

          <Input
            id="password"
            label={t("Password")}
            type="password"
            value={password}
            onChange={handlePasswordChange}
            placeholder={t("Enter password")}
            state={statePassword}
            alertState={errors.password}
            pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\\\\d)[A-Za-z\\\\d@$!%*?&-_{[}]]]{8,}$"
            required
          />
          <Input
            id="confirm-password"
            label={t("Confirm Password")}
            type="password"
            value={confirmPassword}
            onChange={handleConfirmPasswordChange}
            placeholder={t("Enter confirm password")}
            state={stateConfirmPassword}
            alertState={errors.confirmPassword}
            pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\\\\d)[A-Za-z\\\\d@$!%*?&-_{[}]]]{8,}$"
            required
            ref={confirmPasswordRef}
          />
        </div>

        <Input
          id="agreement-checkbox"
          style={{ margin: "24px 0" }}
          type="checkbox"
          label={[
            t("I agree to the"),
            <button type="button" onClick={() => tearmAndConditions()} >{t("Terms and Conditions")}</button>,
            " & ",
            <button type="button" onClick={() => privacyPolicy()}>{t("Privacy Policy")}</button>,
          ]}
          value={agreement}
          onChange={handleAgreement}
        />

        <button
          className="form-default__submit"
          type="submit"
          disabled={!agreement}
        >
          {t("Sign Up")}
        </button>
      </form>) : null}

      {step ? (
        <form onSubmit={handleSubmitIdentities}>
          <div className="form-default flex-column">
            <DropdownInput
              id="country"
              label={t("Country")}
              value={country}
              setValue={setCountry}
              placeholder={t("Enter Country")}
              required
              options={["Aland Islands",
                "Andorra",
                "Austria",
                "Azores",
                "Belgium",
                "Canary Islands",
                "Cyprus",
                "Estonia",
                "Finland",
                "France",
                "Germany",
                "Gibraltar",
                "Greece",
                "Ireland",
                "Italy",
                "Latvia",
                "Lithuania",
                "Luxembourg",
                "Madeira",
                "Malta",
                "Monaco",
                "Netherlands",
                "Portugal",
                "San Marino",
                "Slovakia",
                "Slovenia",
                "Spain",
                "Bulgaria",
                "Croatia",
                "Czech Republic",
                "Denmark",
                "Gibraltar",
                "Hungary",
                "Iceland",
                "Liechtenstein",
                "Norway",
                "Poland",
                "Romania",
                "Sweden",
                "Switzerland",
                "United Kingdom"]}
            />
            <Input
              id="address"
              label={t("Address")}
              type="text"
              value={address}
              onChange={handleAddressChange}
              placeholder={t("Enter address")}
              state={state}
              pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\\\\d)[A-Za-z\\\\d@$!%*?&-_{[}]]]{8,}$"
              required
            />
            <Input
              id="city"
              label={t("City")}
              type="text"
              value={city}
              onChange={handleCityChange}
              placeholder={t("Enter city")}
              pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\\\\d)[A-Za-z\\\\d@$!%*?&-_{[}]]]{8,}$"
              state={state}
              required
            />
            <Input
              id="zipCode"
              label={t("Zip Code")}
              type="text"
              value={zipCode}
              onChange={handleZipCodeChange}
              placeholder={t("Enter zip code")}
              state={state}
              required
            />

            <div className="component-input">
              <label htmlFor="birthday">{t("Your date of birth")}</label>

              <input
                type="date"
                id="birthday"
                name="birthday"
                value={selectedDate}
                onChange={handleChange}
                placeholder="Enter your birthday"
              />
              {datePikerError && <p className={datePikerState}>{datePikerError}</p>}
            </div>
            <button
              className="form-default__submit"
              type="submit"
            >{t("Send")}</button>
          </div>
        </form>

      ) : null}
    </div>
  );
};

export default SignUp;
